/** @format */
import {
    CheckoutType,
    PaymentMethodType,
} from '@toucan/client/core/checkout/config/types';

export function getPaymentMethodFromCheckoutType(checkoutType: CheckoutType) {
    switch (checkoutType) {
        case CheckoutType.CARD:
            return PaymentMethodType.CARD;
        case CheckoutType.IDEAL:
            return PaymentMethodType.IDEAL;
        case CheckoutType.EPS:
            return PaymentMethodType.EPS;
        case CheckoutType.BANCONTACT:
            return PaymentMethodType.BANCONTACT;
        case CheckoutType.PAYPAL:
        case CheckoutType.PAYPAL_CREDIT:
            return PaymentMethodType.PAYPAL;
        case CheckoutType.BALANCE:
            return PaymentMethodType.SELL_BALANCE;
    }
}
